import { render, staticRenderFns } from "./TabGeneralComponent.vue?vue&type=template&id=01057795"
import script from "./TabGeneralComponent.vue?vue&type=script&lang=js"
export * from "./TabGeneralComponent.vue?vue&type=script&lang=js"
import style0 from "./TabGeneralComponent.vue?vue&type=style&index=0&id=01057795&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports